// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment-timezone';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { UTC } from '../../infrastructure/constants/common';
import { EmptyEvents } from './EmptyEvents';
import { Events } from './Event/Events';

const LODGING = 'Lodging';
const FLIGHT = 'Flight';

export class DayEvents extends React.PureComponent {
  timeCompare = (a, b, overboard) => {
    if (a.timeTBD && b.timeTBD) {
      return 0;
    }
    if (!a.timeTBD && b.timeTBD) {
      return -1;
    }
    if (a.timeTBD && !b.timeTBD) {
      return 1;
    }
    if (overboard) {
      if (
        moment(a.startTime).tz(UTC).valueOf() <
        moment(b.startTime).tz(UTC).valueOf()
      ) {
        return -1;
      }
      if (
        moment(a.startTime).tz(UTC).valueOf() >
        moment(b.startTime).tz(UTC).valueOf()
      ) {
        return 1;
      }
      return 0;
    }
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { day } = this.props;
    let firstTime = moment(a.startTime).tz(UTC);
    let secondTime = moment(b.startTime).tz(UTC);
    if (a.eventCategory === LODGING) {
      if (
        moment(a.endTime).hours(0).minutes(0).tz(UTC).format('YYYY-MM-DD') ===
        moment(day).tz(UTC).format('YYYY-MM-DD')
      ) {
        firstTime = moment(a.endTime).tz(UTC);
      }
    }
    if (b.eventCategory === LODGING) {
      if (
        moment(b.endTime).hours(0).minutes(0).tz(UTC).format('YYYY-MM-DD') ===
        moment(day).tz(UTC).format('YYYY-MM-DD')
      ) {
        secondTime = moment(b.endTime).tz(UTC);
      }
    }
    if (
      a.eventCategory === FLIGHT &&
      moment(a.endTime).tz(UTC).format('YYYY-MM-DD') ===
        moment(day).tz(UTC).format('YYYY-MM-DD')
    ) {
      firstTime = moment(a.endTime).tz(UTC);
    }
    if (
      b.eventCategory === FLIGHT &&
      moment(b.endTime).tz(UTC).format('YYYY-MM-DD') ===
        moment(day).tz(UTC).format('YYYY-MM-DD')
    ) {
      secondTime = moment(b.endTime).tz(UTC);
    }
    if (firstTime.valueOf() < secondTime.valueOf()) {
      return -1;
    }
    if (firstTime.valueOf() > secondTime.valueOf()) {
      return 1;
    }
    return 0;
  };

  sortByTime = events => events.sort(this.timeCompare);

  render() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      events,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      day,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      addEvent,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      status,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      overboard,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      tbd,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      members,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      onEventClick,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      tz,
    } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const isEmpty = !events || events.length === 0;
    if (tbd) {
      return (
        <div className='events-content'>
          {isEmpty ? (
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <EmptyEvents addEvent={addEvent} status={status} day='TBD' />
          ) : (
            <Events
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              tbd
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              events={this.sortByTime(events, false)}
              members={members}
              onEventClick={onEventClick}
              tz={tz}
            />
          )}
        </div>
      );
    }
    if (overboard) {
      return (
        <div className='events-content'>
          <Events
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            overboard
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            events={this.sortByTime(events, true)}
            members={members}
            onEventClick={onEventClick}
            tz={tz}
          />
        </div>
      );
    }
    return (
      <div className='events-content'>
        {isEmpty ? (
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <EmptyEvents addEvent={addEvent} status={status} day={day} />
        ) : (
          <Events
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            overboard={false}
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            events={this.sortByTime(events, false)}
            members={members}
            day={day}
            onEventClick={onEventClick}
            tz={tz}
          />
        )}
      </div>
    );
  }
}
